/**
 * Русская локаль интерфейса.
 *
 * Она эталонная: перечень её ключей и есть тип `MessageKey`. Поэтому тип
 * словаря здесь не объявляется — он выводится из самого литерала, иначе
 * перечень ссылался бы сам на себя.
 */

export const RU_MESSAGES = {
  'app.title': 'Type2X',
  'app.tagline': 'Адаптивный тренажёр слепой печати',
  'update.available': 'Вышла новая версия приложения.',
  'update.apply': 'Обновить',

  'onboarding.title': 'Учитесь печатать вслепую',
  'onboarding.lead':
    'Тренажёр смотрит, какие клавиши и сочетания даются вам труднее, и собирает упражнения из них. Не из общего списка для всех, а из ваших.',
  'onboarding.setup': 'Раскладка, система и форма клавиатуры',
  'onboarding.measures':
    'Измеряются промежутки между нажатиями и ошибки по клавишам. Набранный текст никуда не отправляется.',
  'onboarding.measuresMore': 'Что уходит на сервер',
  'onboarding.measuresBody':
    'На сервер уходят только итоги занятия: сколько знаков, какая точность, какие клавиши дались тяжело. Сами нажатия и ваш текст остаются в этом браузере.',
  'onboarding.language': 'Язык обучения',
  'onboarding.language.ru': 'Русский',
  'onboarding.language.en': 'Английский',
  'onboarding.layout': 'Раскладка',
  'onboarding.platform': 'Операционная система',
  'onboarding.platform.windows': 'Windows',
  'onboarding.platform.macos': 'macOS',
  'onboarding.platform.linux': 'Linux',
  'onboarding.form': 'Форма клавиатуры',
  'onboarding.form.ansi': 'ANSI',
  'onboarding.form.iso': 'ISO',
  'onboarding.layoutId.ru-jcuken': 'ЙЦУКЕН',
  'onboarding.layoutId.en-qwerty': 'QWERTY',
  'recommendation.accuracy': 'Снизьте темп и добейтесь точности выше 92 процентов.',
  'recommendation.review': 'Повторите слабые слова в режиме «Мои ошибки».',
  'recommendation.speed': 'Точность высокая — можно осторожно повышать темп.',
  'recommendation.control-test': 'Пройдите контрольный тест на незнакомом тексте.',
  'recommendation.rest': 'Ритм рваный. Сделайте перерыв и вернитесь позже.',
  'onboarding.start': 'Пройти диагностику',
  'onboarding.guest': 'Вы работаете как гость. Прогресс хранится в этом браузере.',

  'diagnostics.title': 'Диагностика',
  'diagnostics.hint': 'Наберите текст в своём обычном темпе. Это измерение, а не экзамен.',

  'practice.title': 'Персональная тренировка',
  'practice.stage.see': 'Посмотрите на слово',
  'practice.stage.split': 'Запомните части',
  'practice.stage.hide': 'Подсказки убираются',
  'practice.stage.type': 'Наберите по памяти',
  'practice.stage.apply': 'Примените в предложении',
  'practice.stage.return': 'Вернёмся к нему позже',

  'mistakes.title': 'Мои ошибки',
  'mistakes.hint': 'Работаем над словом «{word}» по шагам.',
  'mistakes.stages': 'Шаги цикла',
  'mistakes.stagesHint': 'Шаги идут по порядку сами — нажимать их не нужно.',
  'mistakes.chunks': 'Части слова',
  'mistakes.progress': 'Разобрано слов',
  'mistakes.remaining': 'Осталось слов: {count}',
  'mistakes.emptyTitle': 'Слабых мест нет',
  'mistakes.empty': 'Слабых мест не осталось. Возвращайтесь после тренировки.',
  'mistakes.stage.see': 'Посмотрите на слово «{word}» и наберите его.',
  'mistakes.stage.split': 'Запомните части слова и наберите его целиком.',
  'mistakes.stage.hide': 'Подсказки убираются: остаётся подсветка зоны.',
  'mistakes.stage.type': 'Клавиатура скрыта. Наберите слово по памяти.',
  'mistakes.stage.apply': 'Примените слово в предложении.',
  'onboarding.startPath': 'С чего начать',
  'onboarding.start.fundamentals': 'С основ: не умею печатать вслепую',
  'onboarding.start.diagnostics': 'С диагностики: уже как-то печатаю',
  'onboarding.startBasics': 'Начать с основ',
  'fundamentals.title': 'Основы',
  'fundamentals.typing': 'Упражнение',
  'fundamentals.hint': 'Пальцы стоят на домашнем ряду. Смотрите на текст, а не на клавиатуру.',
  'fundamentals.group': 'Осваиваем: {row}, {finger}.',
  'fundamentals.current': 'Сейчас учим:',
  'fundamentals.unlockedCount': 'Открытые клавиши: {open} из {total} — {keys}',
  'fundamentals.progress': 'Пройдено групп клавиш',
  'fundamentals.chunks': 'Пока это короткие сочетания: важно движение, а не смысл.',
  'fundamentals.words': 'Открытых клавиш хватает на настоящие слова — переходим к ним.',
  'fundamentals.done': 'Все клавиши открыты. Дальше — персональная тренировка.',
  'fundamentals.row.home': 'домашний ряд',
  'fundamentals.row.top': 'верхний ряд',
  'fundamentals.row.bottom': 'нижний ряд',
  'fundamentals.finger.index': 'указательные пальцы',
  'fundamentals.finger.middle': 'средние пальцы',
  'fundamentals.finger.ring': 'безымянные пальцы',
  'fundamentals.finger.pinky': 'мизинцы',
  // Режимы «Цифры», «Пунктуация» и «Специальные символы» (ТЗ §6, режимы 8–10).
  'symbols.title.digits': 'Цифры',
  'symbols.title.punctuation': 'Пунктуация',
  'symbols.title.special-characters': 'Специальные символы',
  'symbols.typing': 'Упражнение',
  'symbols.group': 'Осваиваем: {characters}.',
  'symbols.unlockedCount': 'Открытые символы: {open} из {total} — {keys}',
  'symbols.progress': 'Пройдено групп символов',
  'symbols.shift': 'Символы с Shift',
  'symbols.shiftHint': '{character} — это Shift и клавиша {base}.',
  'symbols.hint.digits': 'Цифры набираются группами по три: важно движение, а не число.',
  'symbols.hint.punctuation': 'Знаки препинания — внутри предложения: наберите его целиком.',
  'symbols.hint.special-characters': 'Shift нажимается мизинцем противоположной руки.',
  'symbols.done': 'Все символы режима открыты.',
  // Режимы «Скорость» и «Точность» (ТЗ §6, режимы 6 и 7).
  'tempo.title.speed': 'Скорость',
  'tempo.title.accuracy': 'Точность',
  'tempo.typing': 'Прогон',
  'tempo.goal.speed': 'Цель: {cpm} знаков в минуту без потери точности.',
  'tempo.goal.accuracy': 'Спокойный темп: около {cpm} знаков в минуту.',
  'tempo.hint': 'Ступень поднимается, когда темп удержан дважды подряд.',
  'tempo.stage.speed': 'Не смотрите на клавиатуру: взгляд на неё и держит темп внизу.',
  'tempo.stage.accuracy': 'Не спешите: строка засчитывается только без единой ошибки.',
  'tempo.progress': 'Пройдено прогонов',
  'tempo.done': 'Занятие закончено.',
  'tempo.verdict.held': 'Темп взят. Ещё раз — и ступень поднимется.',
  'tempo.verdict.advanced': 'Ступень поднята: цель стала выше.',
  'tempo.verdict.slow': 'Точность в порядке, но до цели не хватило скорости.',
  'tempo.verdict.dropped': 'Точность просела — ступень опустилась на шаг.',
  'tempo.verdict.clean': 'Чисто, без единой ошибки.',
  'tempo.verdict.retry': 'Была ошибка: строка повторяется с начала.',
  'tempo.verdict.deferred': 'Строка отложена до следующего раза.',
  // Режимы «Developer Pack» и «Email and Web Pack» (ТЗ §6, режимы 11 и 12).
  'packs.title.developer-pack': 'Developer Pack',
  'packs.title.email-web-pack': 'Email and Web Pack',
  'packs.typing': 'Упражнение',
  'packs.group': 'Осваиваем: {tokens}.',
  'packs.unlockedCount': 'Открытые сочетания: {open} из {total} — {tokens}',
  'packs.progress': 'Пройдено групп сочетаний',
  'packs.shift': 'Символы с Shift',
  'packs.shiftHint': '{character} — это Shift и клавиша {base}.',
  'packs.layout': 'Занятие идёт в латинской раскладке: переключите её перед началом.',
  'packs.hint.developer-pack': 'Оператор набирается целиком: не по половине, а одним движением.',
  'packs.hint.email-web-pack': 'Адреса учебные: доменов и почтовых ящиков из них не существует.',
  'packs.done': 'Все сочетания пакета открыты.',
  // Режим тренировки переключения раскладок (ТЗ §8.1).
  'layoutSwitch.title': 'Переключение раскладок',
  'layoutSwitch.typing': 'Упражнение',
  'layoutSwitch.explain': 'Язык меняется на каждом фрагменте: переключайте раскладку сами.',
  'layoutSwitch.segments': 'Фрагменты занятия',
  'layoutSwitch.boundary': '— здесь меняется раскладка',
  'layoutSwitch.count': 'Смен раскладки за занятие: {count}.',
  'layoutSwitch.language.ru': 'Русский:',
  'layoutSwitch.badge.ru': 'RU',
  'layoutSwitch.badge.en': 'EN',
  'layoutSwitch.language.en': 'Латиница:',
  'layoutSwitch.hint': 'Клавиатура скрыта: раскладки две, а показать можно одну.',

  'modes.group.learn': 'Учиться',
  'modes.group.signs': 'Знаки и цифры',
  'modes.group.latin': 'Латиница',
  'modes.group.own': 'Скорость и свой текст',
  'modes.lockedWhy':
    'Материал набирается чужой раскладкой: пока её буквы не даются, занятие будет состоять из ошибок, а не из тренировки. Посмотреть, что внутри, можно и сейчас.',
  'modes.tryAnyway': 'Всё равно попробовать',
  'modes.locked.en':
    'Код, адреса и переключение раскладок набираются латиницей. Эти режимы откроются, когда каждая её буква будет набираться уверенно: сейчас {mastered} из {total}.',
  'modes.locked.ru':
    'Переключение раскладок идёт в двух раскладках, и вторая из них — кириллица. Режим откроется, когда каждая её буква будет набираться уверенно: сейчас {mastered} из {total}.',
  'modes.train.en': 'Тренировать латиницу',
  'modes.train.ru': 'Тренировать кириллицу',
  'nav.forward': 'Вперёд',
  'nav.label': 'Переходы',
  'nav.back': 'Назад',
  'nav.account.checking': 'Проверяем',
  'nav.account.checkingAria': 'Проверяем, вошли ли вы. Открыть аккаунт',
  'nav.account.guest': 'Гость',
  'nav.account.guestAria': 'Вы не вошли, прогресс хранится в этом браузере. Открыть аккаунт',
  'nav.account.signedIn': 'Вошли',
  'nav.account.signedInAria': 'Вы вошли, адрес подтверждён. Открыть аккаунт',
  'nav.account.unverified': 'Без подтверждения',
  'nav.account.unverifiedAria': 'Вы вошли, адрес ещё не подтверждён. Открыть аккаунт',
  'home.title': 'Что дальше',
  'home.explain':
    'Продолжить начатое, взять другой режим или поменять то, с чего начали — здесь всё сразу.',
  'home.continue': 'Продолжить тренировку',
  'home.startPath': 'С чего идёт обучение',
  'home.look': 'Посмотреть и сохранить',
  'legal.privacy': 'Политика приватности',
  'legal.terms': 'Условия использования',
  'legal.agreement':
    'Регистрируясь, вы соглашаетесь с условиями использования и политикой приватности.',
  'legal.analytics':
    'Аналитика по умолчанию выключена: без вашего согласия мы не собираем ничего сверх нужного для обучения.',
  'language.training': 'Язык тренировки',
  'language.setupTitle': 'Новый язык: {language}',
  'language.setupHint':
    'Прогресс прежнего языка остаётся на месте: к нему можно вернуться в любой момент.',
  'language.setupCancel': 'Вернуться к прежнему языку',
  // Внешний вид: тема и фокус-режим (ТЗ UX-01, UX-03).
  'appearance.theme': 'Тема оформления',
  'appearance.theme.system': 'Как в системе',
  'appearance.theme.light': 'Светлая',
  'appearance.theme.dark': 'Тёмная',
  'appearance.focusOn': 'Фокус',
  'appearance.focusOff': 'Выйти из фокуса',
  'appearance.focusEntered': 'Режим без отвлечений включён',
  'appearance.soundOn': 'Звук: вкл',
  'appearance.soundOff': 'Звук: выкл',
  'appearance.gameOn': 'Награды: вкл',
  'appearance.gameOff': 'Награды: выкл',

  // Настройки в шапке: одна кнопка вместо ряда панелей (ТЗ FR-EN-83).
  'settings.title': 'Настройки',
  'settings.close': 'Закрыть настройки',
  // Занятие: текст сразу, подробности — по требованию (ТЗ FR-EN-84).
  'drill.details': 'Подробнее о задании',
  'home.tune': 'Настроить обучение',

  // Ступени набора. Их называют два экрана — диагностика и контрольный тест,
  // — поэтому ключи названы по шкале, а не по экрану, где она появилась
  // первой: две копии слова «Уверенный» рано или поздно разойдутся.
  'skillLevel.searching': 'Ищете клавиши',
  'skillLevel.beginner': 'Начинающий',
  'skillLevel.confident': 'Уверенный',
  'skillLevel.fast': 'Быстрый',
  'skillLevel.professional': 'Профессиональный',
  'skillLevel.effectiveCpm': '{cpm} знаков в минуту с учётом точности',

  'diagnosticResult.title': 'Ваш уровень',
  'diagnosticResult.explain.searching':
    'Каждая клавиша пока находится отдельно. Это нормальное начало: скорость появляется после того, как руки запомнят расположение.',
  'diagnosticResult.explain.beginner':
    'Клавиатура знакома, но пальцы ещё выбирают путь. Дальше растёт не столько скорость, сколько ровность.',
  'diagnosticResult.explain.confident':
    'Обычный рабочий темп: текст набирается, не отвлекая на себя. Дальше мешают отдельные слабые сочетания, а не клавиатура целиком.',
  'diagnosticResult.explain.fast':
    'Выше среднего. На этом уровне растут за счёт точности: исправления съедают больше, чем даёт разгон.',
  'diagnosticResult.explain.professional':
    'Профессиональная скорость. Смысл занятий здесь — редкие сочетания, знаки и переключение раскладок, а не буквы.',
  'diagnosticResult.accurateButSlow':
    'Вы почти не промахиваетесь, но между нажатиями проходит около секунды. Так печатают в двух случаях: когда ищут клавиши глазами и когда движение верное, но ещё не стало привычным. Что из этого — знаете только вы; и то и другое лечится основами.',
  'diagnosticResult.weakSpots': 'Что даётся хуже всего',
  'diagnosticResult.nextStep': 'Что дальше',
  'diagnosticResult.recommend.fundamentals':
    'Предлагаем начать с основ: клавиши открываются группами, и руки встают на место.',
  'diagnosticResult.recommend.practice':
    'Предлагаем персональную тренировку: материал подбирается по вашим слабым местам.',
  'diagnosticResult.continue.fundamentals': 'Начать с основ',
  'diagnosticResult.continue.practice': 'К тренировке',
  'diagnosticResult.retake': 'Пройти заново',
  'diagnosticResult.notAVerdict':
    'Это точка отсчёта, а не приговор: уровень пересчитывается после каждого занятия, и одно неудачное измерение ни на что не влияет.',
  // Отчёт по клавишам, сочетаниям и словам (ТЗ UX-07).
  'report.summary':
    'Единиц под наблюдением: {tracked}. Освоено: {mastered}. Ждут повторения: {due}.',
  'report.weakest': 'Что даётся тяжелее всего',
  'report.heatLegend': 'Насколько далеко до освоения',
  'report.title': 'Отчёт по навыку',
  'report.open': 'Отчёт по навыку',
  'report.back': 'Вернуться к тренировке',

  'achievements.title': 'Достижения',
  'quests.period.day': 'Сегодня',
  'quests.period.week': 'На этой неделе',
  'quests.title': 'Задания',
  // Сезонное испытание месяца (ТЗ FR-GM-07).
  'season.title': 'Сезон',
  'season.name': '{month} {year}',
  'season.explain':
    'Сезон — календарный месяц с одной целью. Испытание известно заранее и повторяется по кругу; незакрытый сезон ничего не отнимает.',
  'season.challenge.practice-days': 'Заниматься {target} дней за месяц.',
  'season.challenge.characters': 'Набрать {target} символов за месяц.',
  'season.challenge.clean-days': 'Провести {target} дней с точностью не ниже 95 процентов.',
  'season.month.1': 'январь',
  'season.month.2': 'февраль',
  'season.month.3': 'март',
  'season.month.4': 'апрель',
  'season.month.5': 'май',
  'season.month.6': 'июнь',
  'season.month.7': 'июль',
  'season.month.8': 'август',
  'season.month.9': 'сентябрь',
  'season.month.10': 'октябрь',
  'season.month.11': 'ноябрь',
  'season.month.12': 'декабрь',
  'quests.explain':
    'Недельные считаются по последним семи дням, а не по календарной неделе: воскресный вечер ничего не обнуляет.',
  'quests.done': 'выполнено',
  'quests.name.daily-session': 'Сегодня: провести занятие',
  'quests.name.daily-characters': 'Сегодня: набрать 300 символов',
  'quests.name.daily-accuracy': 'Сегодня: занятие с точностью 95%',
  'quests.name.weekly-days': 'За неделю: заниматься 4 дня',
  'quests.name.weekly-characters': 'За неделю: набрать 1200 символов',
  'quests.name.weekly-accuracy': 'За неделю: три чистых дня',
  'achievements.open': 'Достижения',
  'achievements.summary':
    'Взято рубежей: {earned} из {total}. Достижения бесплатны и остаются с вами навсегда.',
  'achievements.streak': 'Серия занятий',
  'achievements.streakDays': 'Дней подряд: {days}',
  'achievements.streakBest': 'Самая длинная серия: {days}. Всего дней с занятиями: {total}.',
  'achievements.records': 'Личные рекорды',
  'achievements.bestCpm': 'Лучшая скорость занятия: {cpm} знаков в минуту',
  'achievements.bestAccuracy': 'Лучшая точность занятия: {accuracy}%',
  'achievements.bestVerified': 'Лучший подтверждённый результат: {wpm} слов в минуту',
  'achievements.typed': 'Набрано символов за всё время: {characters}',
  'achievements.list': 'Рубежи',
  'achievements.unlocked': 'получено',
  'achievements.name.first-thousand': 'Первая тысяча',
  'achievements.about.first-thousand': 'Набрать первую тысячу символов.',
  'achievements.name.first-verified': 'Без подсказок',
  'achievements.about.first-verified':
    'Пройти контрольный тест: незнакомый текст, клавиатура скрыта, исправления недоступны. Результат подтверждает сервер, поэтому нужен аккаунт.',
  'achievements.name.accuracy-95': 'Точность 95%',
  'achievements.about.accuracy-95': 'Провести занятие с точностью не ниже 95%.',
  'achievements.name.ten-words': 'Десять исправленных',
  'achievements.about.ten-words': 'Довести до уверенного набора десять проблемных слов.',
  'achievements.name.seven-days': 'Неделя практики',
  'achievements.about.seven-days': 'Заниматься семь дней — не обязательно подряд.',
  'achievements.name.verified-35-wpm': 'Тридцать пять',
  'achievements.about.verified-35-wpm': 'Показать 35 слов в минуту на незнакомом тексте.',
  'achievements.name.symbols-confident': 'Знаки и символы',
  'achievements.about.symbols-confident':
    'Уверенно набирать десять знаков препинания и специальных символов.',
  'achievements.name.two-languages': 'Два языка',
  'achievements.about.two-languages':
    'Показать целевой результат на незнакомом тексте в обоих языках.',
  'report.explain': 'Всё, что вы набирали: доля ошибок, задержка и срок повторения.',
  'report.section.keys': 'Клавиши',
  'report.section.combinations': 'Сочетания',
  'report.section.words': 'Слова',
  'report.section.switches': 'Переключение раскладок',
  'report.column.unit': 'Что',
  'report.column.attempts': 'Нажатий',
  'report.column.errors': 'Ошибок',
  'report.column.latency': 'Задержка',
  'report.column.mastery': 'Освоенность',
  'report.column.review': 'Повторить',
  'report.ms': '{value} мс',
  'report.mastered': 'освоено',
  'report.learning': 'в работе',
  'report.emptySectionTitle': 'Раздел пока пуст',
  'report.emptySection': 'Здесь пока ничего не набрано.',
  'report.emptyAllTitle': 'Отчёт пока пуст',
  'report.emptyAll': 'Отчёту пока не о чем рассказать: проведите первое занятие.',
  'report.shown': 'Показано {shown} из {total}.',
  'report.search': 'Поиск: {section}',
  'report.filterGroup': 'Что показать: {section}',
  'report.pageGroup': 'Страницы: {section}',
  'report.filter.all': 'Всё',
  'report.filter.weak': 'Слабые',
  'report.filter.due': 'К повторению',
  'report.filter.mastered': 'Освоенные',
  'report.nothingFoundTitle': 'Ничего не нашлось',
  'report.nothingFound': 'Ничего не нашлось. Измените запрос или фильтр.',
  'report.resetSearch': 'Сбросить поиск и фильтр',
  'report.page': 'Страница {page} из {pages}',
  'report.prev': 'Назад',
  'report.next': 'Дальше',
  'report.untouched': 'Ещё не набирались ни разу: {count}.',
  // Режим «Свой текст» (ТЗ §6, режим 13).
  'customText.title': 'Свой текст',
  'customText.begin': 'Начать занятие',
  'customText.label': 'Вставьте текст, на котором хотите тренироваться',
  'customText.local': 'Текст разбирается на этом устройстве и никуда не отправляется.',
  'customText.typing': 'Упражнение',
  'customText.hint': 'Слова из вашего текста: чаще встречается — чаще повторяется.',
  'customText.words': 'Слов из текста в работе: {count}.',
  'customText.rejected':
    'Пропущено слов, которые не набрать в этой раскладке: {count} ({characters}).',
  'customText.tooShort': 'Нужно хотя бы {count} разных слов: иначе упражнение выродится в повтор.',
  'sentences.title': 'Предложения',
  'sentences.typing': 'Набор предложения',
  'sentences.hint': 'Наберите предложение целиком, со знаками препинания.',
  'sentences.focus': 'Предложение подобрано ради слова «{word}».',
  'sentences.transfer': 'Обычный текст: проверяем, держится ли навык.',
  'sentences.progress': 'Пройдено предложений',
  'sentences.remaining': 'Осталось предложений: {count}',
  'sentences.emptyTitle': 'Предложений пока нет',
  'sentences.empty': 'Предложений для этого языка пока нет.',

  'control.title': 'Контрольный тест',
  'control.hint': 'Незнакомый текст без подсказок. Печатайте спокойно и точно.',
  'control.rules': 'Правила теста',
  'control.rule.unfamiliar': 'Текст незнакомый: он не повторяет упражнения.',
  'control.rule.noCorrections': 'Исправлять нельзя: Backspace во время теста не работает.',
  'control.rule.noHints': 'Подсказок нет: клавиатура и подсветка клавиш скрыты.',
  'control.rule.progressKept':
    'Не засчитанный результат не отменяет прогресс: он идёт только в рейтинг.',
  'control.begin': 'Начать тест',
  'control.badge': 'Контроль',
  'control.retentionTitle': 'Отложенная проверка',
  'control.retentionHint': 'Проверим, сохранился ли навык после перерыва.',
  'control.start': 'Пройти контрольный тест',
  'control.startRetention': 'Пройти отложенную проверку',
  'control.accepted': 'Результат подтверждён.',
  'control.rejected': 'Результат не засчитан в рейтинг. Прогресс сохранён.',
  'control.retentionCounted': 'Навык сохранён после перерыва.',
  'control.rating': 'Рейтинг: {rating}',
  'control.levelTitle': 'Уровень по этой проверке:',
  'control.levelUnknown': 'Этого прогона мало, чтобы называть уровень.',
  'control.belowRequirements': 'Результат ниже минимальных требований и в рейтинг не идёт.',
  'control.waiting': 'Отправляем результат…',
  'control.needsAccount':
    'Результат не засчитан: контрольные результаты хранятся в аккаунте. Прогресс тренировок остался в этом браузере.',
  'control.notAccepted': 'Сервер не принял результат. Попробуйте позже.',
  'control.offline': 'Нет связи с сервером. Результат не отправлен.',
  'control.back': 'Вернуться к тренировке',
  'result.retentionDue': 'Пора проверить, сохранился ли навык после перерыва.',
  'recommendation.retention':
    'Пройдите отложенную проверку: она подтверждает, что навык закрепился.',
  'metrics.wpm': 'WPM',
  'metrics.cpm': 'CPM',
  'metrics.accuracy': 'Точность',
  'metrics.rhythm': 'Ритм',
  'metrics.corrections': 'Исправления',

  'result.done': 'Занятие закончено.',
  'result.noWeakUnitsTitle': 'Слабых мест в этом занятии нет',
  'result.noWeakUnits': 'В этом занятии ошибок не было.',
  'result.title': 'Результат',
  'result.baseline': 'Стартовый уровень',
  'result.current': 'Сейчас',
  'result.growth': 'Рост',
  'result.weakUnits': 'Слабые места',
  'result.achievementEarned': 'Новый рубеж: {names}',
  'result.xpEarned': 'Получено XP: {amount}',
  'result.level': 'Уровень {level}',
  'result.nextStep': 'Следующий шаг',
  'result.otherModes': 'Другие режимы',
  // Кнопка называет режим, а не просто обещает занятие: экран результата один
  // на все режимы, и «ещё одна тренировка» уводила из того, чем занимались.
  'result.againMode': 'Ещё раз: {mode}',
  'result.continueTo': 'Продолжить: {mode}',
  'result.verifiedHint':
    'Подтвердите результат на незнакомом тексте, чтобы он учитывался в рейтинге.',

  'account.title': 'Сохранить прогресс',
  'account.explain':
    'Регистрация переносит прогресс из этого браузера и открывает 14 дней Premium.',
  'account.email': 'Электронная почта',
  'account.password': 'Пароль',
  'account.submit': 'Зарегистрироваться и перенести прогресс',
  'account.accessOpen': 'Всё открыто',
  'account.accessOpenHint':
    'Все режимы доступны без ограничений. Прогресс, достижения и история занятий остаются с вами.',
  'account.accessUnverified': 'Адрес не подтверждён',
  'account.privacyTitle': 'Приватность',
  'account.claimed': 'Прогресс перенесён в аккаунт.',
  'account.verified': 'Адрес подтверждён.',
  'account.signedInAs': 'Вы вошли как {email}.',
  'account.awaitingAddress': 'Письмо отправлено на {email}.',
  'account.progressAlready': 'Прогресс этого браузера уже был в аккаунте.',
  'account.progressTaken':
    'Прогресс этого браузера принадлежит другому аккаунту и остался на месте.',
  'account.login': 'Войти',
  'account.loginHint': 'Уже есть аккаунт? Введите тот же адрес и пароль и войдите.',
  'account.unverified': 'Адрес не подтверждён, поэтому Premium пока не открыт.',
  'account.forgot': 'Забыли пароль?',
  'account.resetRequested': 'Если такой адрес зарегистрирован, письмо со ссылкой отправлено.',
  'reset.title': 'Новый пароль',
  'reset.explain': 'Задайте новый пароль. Прежние сессии закроются, войти нужно будет заново.',
  'reset.password': 'Новый пароль',
  'reset.submit': 'Сохранить пароль',
  'reset.done': 'Пароль изменён. Войдите с новым паролем.',
  'reset.toLogin': 'Перейти ко входу',
  'privacy.title': 'Ваши данные',
  'privacy.explain': 'Прогресс можно забрать с собой: в файле будет всё, что о вас известно.',
  'privacy.dangerTitle': 'Опасная зона',
  'privacy.dangerExplain': 'Здесь аккаунт удаляется навсегда. Отменить это действие нельзя.',
  'privacy.export': 'Скачать мой прогресс',
  'privacy.delete': 'Удалить аккаунт',
  'privacy.deleteWarning':
    'Удаление необратимо: аккаунт, прогресс и результаты исчезнут вместе с ним.',
  'privacy.deletePassword': 'Пароль для подтверждения',
  'privacy.deleteConfirm': 'Подтвердить удаление',
  'privacy.deleted': 'Аккаунт удалён. Прогресс в этом браузере тоже стёрт.',
  // Выход — не опасное действие: аккаунт остаётся, навык возвращается при
  // следующем входе. Но браузер он освобождает целиком, и об этом сказано.
  'logout.title': 'Выход',
  'logout.explain':
    'Прогресс останется в аккаунте и вернётся, когда вы войдёте снова — здесь или на другом устройстве. Из этого браузера он уйдёт: за общим компьютером ваше не должно достаться следующему.',
  'logout.action': 'Выйти из аккаунта',
  'logout.pending':
    'Итоги последних занятий ещё не ушли на сервер. Если выйти сейчас, они не вернутся ниоткуда.',
  'logout.force': 'Всё равно выйти',
  'account.continue': 'Продолжить тренировку',
  'account.awaiting':
    'Письмо со ссылкой отправлено. Перейдите по ней, чтобы подтвердить адрес и перенести прогресс.',
  'account.awaitingHint':
    'Прогресс остаётся в этом браузере и никуда не денется, пока вы не подтвердите адрес.',
  'account.resend': 'Отправить письмо ещё раз',
  'account.resent': 'Письмо отправлено ещё раз.',
  'account.verifying': 'Подтверждаем адрес…',
  'account.verifyFailed': 'Ссылка недействительна или устарела. Попросите новое письмо.',
  'account.error.invalid-email': 'Проверьте адрес электронной почты.',
  'account.error.weak-password': 'Пароль должен быть не короче 10 символов.',
  'account.error.invalid-credentials': 'Неверный адрес или пароль.',
  'account.error.progress-taken': 'Прогресс этого браузера принадлежит другому аккаунту.',
  'account.error.rate-limited': 'Слишком много попыток. Попробуйте позже.',
  'account.error.offline': 'Нет связи с сервером. Прогресс сохранён локально.',
  'account.error.server-error': 'Не удалось завершить регистрацию. Попробуйте позже.',
  'friends.title': 'Друзья',
  'friends.explain':
    'Дружеский рейтинг связывает по коду приглашения: адрес электронной почты при этом не раскрывается. Свой код можно передать кому угодно, чужой — никому: по нему добавляют в друзья.',
  'friends.yourCode': 'Ваш код:',
  'friends.link': 'Ссылка-приглашение',
  'friends.inviteTitle': 'Вас зовут в друзья',
  'friends.invite':
    'Вы открыли приложение по ссылке-приглашению с кодом {code}. Добавить этого человека в друзья? Он увидит ваш псевдоним и место в рейтинге — и ничего больше.',
  'friends.inviteAccept': 'Добавить в друзья',
  'friends.inviteDecline': 'Не добавлять',
  'friends.addLabel': 'Код друга',
  'friends.add': 'Добавить друга',
  'friends.remove': 'Убрать',
  'friends.emptyTitle': 'Друзей пока нет',
  'friends.empty': 'Обменяйтесь кодами с тем, с кем хотите сравнивать успехи.',
  'friends.boardTitle': 'Среди друзей',
  'friends.notParticipating': 'не участвует в рейтинге',
  'friends.unavailable': 'Друзья открываются вместе с аккаунтом.',
  'friends.error.not-found': 'Такого кода нет. Проверьте, что он переписан целиком.',
  'friends.error.full': 'Список друзей заполнен. Уберите кого-нибудь, чтобы добавить нового.',
  'friends.error.failed': 'Не удалось добавить. Попробуйте позже.',
  'leaderboard.title': 'Рейтинг',
  'leaderboard.explain':
    'Место в рейтинге считает сервер по засчитанным контрольным тестам. Участие по желанию: по умолчанию вас в таблице нет.',
  'leaderboard.loading': 'Спрашиваем сервер…',
  'leaderboard.unavailableTitle': 'Рейтингу нужен аккаунт',
  'leaderboard.unavailable':
    'Место считается по контрольным тестам, а они привязаны к аккаунту. Прогресс при этом остаётся вашим и без него.',
  'leaderboard.emptyTitle': 'Таблица пока пуста',
  'leaderboard.empty': 'Ни одного засчитанного контрольного результата на этом языке ещё нет.',
  'leaderboard.computed': 'Снимок посчитан {moment} UTC, формула {version}.',
  'leaderboard.you': 'вы',
  'leaderboard.name': 'Псевдоним в таблице',
  'leaderboard.saveName': 'Сохранить псевдоним',
  'leaderboard.saveFailed': 'Сервер не принял изменение. Попробуйте позже.',
  'leaderboard.kinds': 'Вид рейтинга',
  'leaderboard.kind.progress': 'Прогресс',
  'leaderboard.kind.skill': 'Навык',
  'leaderboard.kind.accuracy': 'Точность',
  'leaderboard.kind.consistency': 'Регулярность',
  'leaderboard.kind.weekly-growth': 'Рост за неделю',
  'leaderboard.hint.progress':
    'Порядок — по основному рейтингу: рост от первого замера, навык, точность, сохранение и разнообразие режимов.',
  'leaderboard.hint.skill': 'Порядок — по скорости лучшего засчитанного контрольного теста.',
  'leaderboard.hint.accuracy':
    'Порядок — по точности лучшего засчитанного теста: точность на своей скорости, а не в нарочито медленном прогоне.',
  'leaderboard.hint.consistency':
    'Порядок — по дням с проверками за четыре недели и по сохранению навыка при отложенной проверке.',
  'leaderboard.hint.weekly-growth':
    'Порядок — по росту скорости за неделю. Кто на этой неделе не проверялся, в этой таблице не показан: измерять нечего.',
  'leaderboard.column.metric.consistency': 'Регулярность',
  'leaderboard.column.metric.weekly-growth': 'Рост',
  'leaderboard.column.rank': 'Место',
  'leaderboard.column.name': 'Участник',
  'leaderboard.column.rating': 'Рейтинг',
  'leaderboard.column.wpm': 'Слов в минуту',
  'leaderboard.column.accuracy': 'Точность',
  'leaderboard.consent': 'Участвовать в рейтинге',
  'leaderboard.consentHint': 'По умолчанию вы не показываетесь в таблицах лидеров.',
  'keyboard.requiredTitle': 'Здесь нужна физическая клавиатура',
  'keyboard.requiredBody':
    'Слепая печать тренируется на настоящих клавишах: экранная клавиатура телефона для неё не годится. Откройте Type2X на компьютере — или подключите клавиатуру и нажмите на ней любую клавишу.',
  'keyboard.requiredWorks':
    'С телефона доступно остальное: прогресс, отчёт по навыку, достижения и аккаунт.',
  'diagnosticResult.analysed': 'Измерено по {count} нажатиям.',
  'diagnosticResult.sampleLimited':
    'Нажатий было {count} — мало для устойчивого измерения. Числа ниже приблизительные.',
  'diagnosticResult.definitions': 'Что означают эти числа',
  'metrics.explain.wpm': 'Скорость — слова в минуту: пять знаков считаются словом.',
  'metrics.explain.accuracy':
    'Точность — доля клавиш, набранных с первого раза. Исправленная ошибка остаётся ошибкой.',
  'metrics.explain.rhythm':
    'Ритм — насколько ровные промежутки между нажатиями. Ровный ритм важнее рывков.',
  'common.locked': 'Закрыто',
  'home.mastered': 'Освоено {mastered} из {total} клавиш',
  'home.continueTo': 'Продолжить: {mode}',
  'home.legend': 'Закрашены освоенные клавиши',
  'fundamentals.purpose': 'Клавиши группами: сначала домашний ряд, потом остальные.',
  'mistakes.purpose': 'Слова, в которых вы промахиваетесь чаще всего.',
  'sentences.purpose': 'Связный текст со знаками препинания и заглавными.',
  'symbols.purpose.digits': 'Верхний ряд цифр, не глядя на клавиатуру.',
  'symbols.purpose.punctuation': 'Точки, запятые, тире и кавычки.',
  'symbols.purpose.special-characters': 'Скобки, слэши и знаки верхнего регистра.',
  'tempo.purpose.speed': 'Короткие забеги на темп без остановок.',
  'tempo.purpose.accuracy': 'Медленно и без единой ошибки.',
  'packs.purpose.developer-pack': 'Код: скобки, операторы, имена переменных.',
  'packs.purpose.email-web-pack': 'Адреса почты и ссылки целиком.',
  'layoutSwitch.purpose': 'Переход с одной раскладки на другую и обратно.',
  'customText.purpose': 'Ваш текст вместо нашего.',
};
